﻿import components = require("./scripts/ts/modules/components");
import context = require("./scripts/ts/modules/context");
import utilities = require("./scripts/ts/modules/utilities");
import lazzyLoader = require("./scripts/ts/modules/lazzyLoader");
import core = require("./scripts/ts/core");

declare function require(name: string): any;

(g => {
    const jsUtilities = require('./scripts/js/jsUtilities');
    const jsClasses = require('./scripts/js/jsClasses');

    //Modules principaux
    g.main = {
        core: core,
        context: context,
        utilities: utilities,
        components: components,
        lazzyLoader: lazzyLoader,
        //code non-migré en typescript 
        js: {
            classes: jsClasses,
            utilities: jsUtilities
        }
    };

    //g.jQuery(document).ready(e => {
    //    g.currentContext.runOnDocumentReadyActions(e);
    //});

    // Native
    g.document.onreadystatechange = () => {
        if (document.readyState === "complete")
            g.currentContext.runOnDocumentReadyActions();
    }
})(window as any);
